export const getIsAuth = state => state.monitor.isAuth;
export const getSocketUrl = state => state.monitor.socketUrl;
export const getStatistics = state => state.monitor.statistics;
export const getSessionsList = state => state.monitor.sessionsList;
export const getSession = state => state.monitor.session;
